// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4aa21086","598":"a6cc34fa","703":"f11aeffa","787":"353cd52b"}[chunkId] + ".chunk.js";
};